import { hasPermission as baseHasPermission } from './Permissions'

/** Módulos de capacitación (portal SIA + admin contenido). */
export const SIA_CAPACITACION_MODULE_KEYS = [
    'index',
    'libros',
    'lideres',
    'formatos',
    'cotizadores',
]

/** Módulos operativos del menú principal (permisos sia.manage.*). */
export const SIA_OPERATIONAL_MODULE_KEYS = ['bitacora', 'reclutamiento', 'atencion-cliente', 'cobranza']

export const SIA_MODULE_KEYS = [...SIA_CAPACITACION_MODULE_KEYS, ...SIA_OPERATIONAL_MODULE_KEYS]

export function siaPortalPermission(module, action = 'view') {
    return `sia.portal.${module}.${action}`
}

export function siaManagePermission(module, action = 'view') {
    return `sia.manage.${module}.${action}`
}

export function hasSiaPortal(module, action = 'view') {
    return baseHasPermission(siaPortalPermission(module, action))
}

export function hasSiaManage(module, action = 'view') {
    return baseHasPermission(siaManagePermission(module, action))
}

export function hasAnySiaPortalAccess() {
    if (baseHasPermission('sia.portal') || baseHasPermission('sia.portal.capacitacion')) {
        return true
    }

    const permissions = window.Laravel?.jsPermissions?.permissions ?? []
    const list = Array.isArray(permissions) ? permissions : Object.values(permissions)

    return list.some((name) => typeof name === 'string' && name.startsWith('sia.portal.'))
}

export function hasAnySiaManageAccess() {
    if (baseHasPermission('sia.manage')) {
        return true
    }

    const permissions = window.Laravel?.jsPermissions?.permissions ?? []
    const list = Array.isArray(permissions) ? permissions : Object.values(permissions)

    return list.some((name) => typeof name === 'string' && name.startsWith('sia.manage.'))
}

export function hasSiaAtencionClienteReadonly() {
    if (hasAnySiaManageAccess()) {
        return false
    }

    if (baseHasPermission('sia.portal') || baseHasPermission('sia.portal.capacitacion')) {
        return false
    }

    if (!hasSiaPortal('atencion-cliente', 'view') || hasSiaPortal('atencion-cliente', 'edit')) {
        return false
    }

    const otherPortalModules = SIA_CAPACITACION_MODULE_KEYS.filter((key) => key !== 'atencion-cliente')

    return !otherPortalModules.some((module) => canViewSiaModule(module, false))
}

const SIA_CAPACITACION_MODULES = ['index', 'libros', 'lideres', 'formatos']

/** Módulos que permanecen bajo administración SIA (manage). */
export const SIA_MANAGE_CAPACITACION_MODULES = [
    'index',
    'libros',
    'lideres',
    'formatos',
    'cotizadores',
    'examenes',
]

export function hasAnySiaManageCapacitacionMenuAccess() {
    return SIA_MANAGE_CAPACITACION_MODULES.some((module) => canViewSiaModule(module, true))
}

export function canViewSiaModule(module, manage = false) {
    return manage ? hasSiaManage(module, 'view') : hasSiaPortal(module, 'view')
}

export function canEditSiaModule(module, manage = false) {
    return manage ? hasSiaManage(module, 'edit') : hasSiaPortal(module, 'edit')
}

export function hasAnySiaCapacitacionMenuAccess(manage = false) {
    return SIA_CAPACITACION_MODULES.some((module) => canViewSiaModule(module, manage))
}

export function hasSiaRecruitmentReportsAccess(manage = false) {
    return manage ? hasSiaManage('reclutamiento', 'reportes') : hasSiaPortal('reclutamiento', 'reportes')
}

export function hasSiaCatalogosAccess(module, manage = true) {
    if (!manage) {
        return false
    }

    return hasSiaManage(module, 'catalogos.view') || hasSiaManage(module, 'catalogos.edit')
}
